import React from "react";
import { Link } from "react-router-dom";
import { Section, Eyebrow } from "@/components/PublicLayout";
import { IMG } from "@/lib/images";

export default function About() {
  return (
    <div>
      <Section className="py-16 md:py-24">
        <Eyebrow>About Simo University</Eyebrow>
        <h1 className="font-serif text-4xl md:text-6xl tracking-tight text-ink max-w-4xl">A different paradigm in education.</h1>
        <p className="mt-6 max-w-2xl text-ink/70 text-lg leading-relaxed">
          Simo University is built around one principle: students should progress at the speed of demonstrated mastery, not at the speed of their birth year. We combine mastery-based progression, learning by teaching, recorded daily oral explanation, research from early childhood, advanced mathematics and reasoning, philosophy, entrepreneurship, technology and multilingual education.
        </p>
      </Section>
      <div className="bg-secondary/60 border-y border-border">
        <Section className="py-16 md:py-24 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <Eyebrow>The ecosystem</Eyebrow>
            <h2 className="font-serif text-3xl md:text-4xl text-ink">Flagship. Laboratory. Operating system.</h2>
            <p className="mt-5 text-ink/70 leading-relaxed">Simo University is the flagship and laboratory institution of the UBO education ecosystem and is powered academically by Nucleus. Simo develops and proves pedagogy; Nucleus productises it; UBO distributes it to partner schools.</p>
            <Link to="/invest" className="mt-6 inline-block text-heraldic hover:text-heraldic-700">Investor relations →</Link>
          </div>
          <img src={IMG.math} alt="Advanced reasoning" className="w-full h-80 object-cover rounded-sm" />
        </Section>
      </div>
      <Section className="py-16 md:py-24">
        <div className="grid md:grid-cols-3 gap-10">
          {[["Governance", "/governance", "How the institution is led and held accountable."],
            ["Leadership", "/leadership", "The people responsible for Simo University."],
            ["Educational model", "/educational-model", "Mastery over age, in detail."]].map(([t, to, d]) => (
            <Link key={to} to={to} className="border border-border rounded-sm p-7 hover:bg-secondary transition-colors">
              <div className="font-serif text-2xl text-ink">{t}</div>
              <p className="mt-2 text-ink/60">{d}</p>
            </Link>
          ))}
        </div>
      </Section>
    </div>
  );
}
